module.exports = __webpack_public_path__ + "static/img/jenkins_logo.f8fca90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/jenkins_logo.png
// module id = pGYl
// module chunks = 2